import React from 'react';

// project-imports
import StencilBox from '../../stencils/StencilBox';

// third-party
import { Element } from 'react-scroll';
import ScrollAnimation from 'react-animate-on-scroll';

const InterviewQuestionHomeStencil = ({ data }) => {

    return (
        <>
            <Element
                name="service"
                className="sercice-area eduvibe-service-five service-wrapper-5 edu-section-gap bg-color-white"
            >
                <div className="container eduvibe-animated-shape">
                    <div className="row">
                        <div className="col-lg-12 d-flex justify-content-center">
                            <StencilBox
                                className="pre-title stencil-sm-devic mb--10"
                                width="20%"
                                height="26px"
                                backgroundColor="#F5F5F5"
                            />
                        </div>
                        <div className="col-lg-12 d-flex justify-content-center">
                            <StencilBox
                                className="pre-title stencil-sm-devic"
                                width="50%"
                                height="56px"
                                backgroundColor="#F5F5F5"
                            />
                        </div>
                    </div>

                    {/* <InterviewCategories /> */}
                    <div className={`row g-5 mt--25 `}>
                        {(data || []).map((i) => (
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                className="col-lg-4 col-md-6 col-12"
                                animateOnce={true}
                                key={i}
                            >
                                <div className="service-card service-card-5">
                                    <div className="inner bg-white">
                                        <div className="icon">
                                            <div className='placeholder h-100 w-100'></div>
                                        </div>
                                        <div className="content w-50">
                                            {/* Title Skeleton */}
                                            <h6 className="placeholder-glow mb--0">
                                                <span className="placeholder w-100"></span>
                                            </h6>
                                            <p className="placeholder-glow mb--0">
                                                <span className="placeholder w-50"></span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>

                    <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                        <div className="shape-image shape-image-1">
                            <img src="/images/shapes/shape-19-02.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-2">
                            <img src="/images/shapes/shape-21.png" alt="Shape Thumb" />
                        </div>
                    </div>
                </div>
            </Element>

        </>
    )
}

export default InterviewQuestionHomeStencil;